import { PagesSelectionAction, PagesSelectionActionKeys } from '../actions/pagesSelection';
import { UiAction, UiActionKeys } from '../actions/ui';
import { getSelectedSpreads, SelectedSpreads } from '../utils/helpers';

export interface PagesSelectionState extends SelectedSpreads {
	isActive: boolean;
}

const pagesSelectionInitialState: PagesSelectionState = {
	isActive: false,
	spreadIndices: [],
	lastSelectedSpreadIndex: -1,
	lastSelectedShiftSpreadIndex: -1,
};

export const pagesSelection = (state: PagesSelectionState = pagesSelectionInitialState, action: PagesSelectionAction | UiAction): PagesSelectionState => {
	switch (action.type) {
		case PagesSelectionActionKeys.SET_PAGES_SELECTION:
			return {
				...state,
				isActive: true,
				spreadIndices: [action.currentSpreadIndex],
				lastSelectedSpreadIndex: action.currentSpreadIndex,
			};
		case PagesSelectionActionKeys.SELECT_PAGE_SPREAD: {
			const { spreadIndex, allSpreads, isCtrlPressed, isShiftPressed } = action;
			const { spreadIndices, lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex } = state;

			return {
				...state,
				...getSelectedSpreads(spreadIndex, allSpreads, spreadIndices, lastSelectedSpreadIndex, lastSelectedShiftSpreadIndex, isCtrlPressed, isShiftPressed),
			};
		}
		case PagesSelectionActionKeys.RESTORE_PAGES_SELECTION:
			return {
				...state,
				isActive: true,
				spreadIndices: action.spreadIndices,
				lastSelectedSpreadIndex: action.spreadIndices[0],
			};
		case PagesSelectionActionKeys.RESET_PAGES_SELECTION:
		case UiActionKeys.RESET:
			return pagesSelectionInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/pagesSelection.ts